// extracted by mini-css-extract-plugin
module.exports = {"campo":"campo-detalhamento_campo__3iOkX","label":"campo-detalhamento_label__38Mz-","value":"campo-detalhamento_value__gxxSb"};